/*
 * 宠物档案（受保护接口）+ 文件上传域
 *
 * @Author: Mustafa.Yin
 * @Date: 2026-10-31
 */
import { get, request } from '@/utils/request';

/**
 * 手机号匹配宠物档案（受保护接口：portal token 鉴权，401 自动重试）
 */
export function getPetInfoByContactWay(contactWay, mdmNo) {
  return get('smartreco/api/getPetInfoByContactWay', { contactWay }, {
    apiName: 'getPetInfo',
    auth: 'portal',
    mdmNo,
  });
}

/**
 * 处方 PNG 上传（FormData，不走统一 JSON 序列化）
 * @param {FormData} formData 含 file 字段的表单数据
 */
export function uploadPrescription(formData) {
  return request('smartreco/api/upload', {
    method: 'post',
    data: formData,
    apiName: 'upload',
    timeout: 60000,
  });
}
